/* Codex: scooter native search helpers start */
(function () {
  if (window.__tpsNativeSearchHelpers) return;
  window.__tpsNativeSearchHelpers = true;

  var PROXY_URL = '/apps/scooter-passing/api/suggest';
  var SCRIPT_SRC = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var MIN_QUERY_LENGTH = 2;
  var MAX_ROWS = 3;
  var CATEGORY_KEYWORD_TARGETS = [
    {
      category: 'Verlichting',
      keywords: ['lamp', 'lampen', 'licht', 'lichten', 'verlichting']
    },
    { category: 'Koplampen', keywords: ['koplamp', 'koplampen', 'voorlamp'] },
    { category: 'Achterlichten', keywords: ['achterlicht', 'achterlamp'] },
    { category: 'Knipperlichten', keywords: ['knipperlicht', 'knipperlichten', 'richtingaanwijzer', 'richtingaanwijzers'] },
    { category: 'Remdelen', keywords: ['rem', 'remmen', 'remsysteem'] },
    { category: 'Remblokken', keywords: ['remblok', 'remblokken'] },
    { category: 'Remschijven', keywords: ['remschijf', 'remschijven'] },
    { category: 'Remklauwen', keywords: ['remklauw', 'remklauwen'] },
    { category: 'Remsegmenten', keywords: ['remsegment', 'remsegmenten', 'remschoen', 'remschoenen'] },
    { category: 'Uitlaat', keywords: ['uitlaat', 'uitlaatdelen'] },
    { category: 'Uitlaten', keywords: ['uitlaten', 'demper', 'dempers', 'uitlaatdemper'] },
    { category: 'Bochten', keywords: ['uitlaatbocht', 'bocht'] },
    { category: 'Uitlaatpakkingen', keywords: ['uitlaatpakking', 'uitlaatpakkingen'] },
    { category: 'Filter', keywords: ['filter', 'filters'] },
    { category: 'Luchtfilters', keywords: ['luchtfilter', 'luchtfilters'] },
    { category: 'Luchtfilterelementen', keywords: ['luchtfilterelement', 'luchtfilterelementen', 'filterelement'] },
    { category: 'Oliefilters', keywords: ['oliefilter', 'oliefilters'] },
    { category: 'Variateur & Koppeling', keywords: ['variateur', 'koppeling', 'transmissie'] },
    { category: 'Variorolsets', keywords: ['variorol', 'variorollen', 'rollen', 'rolset'] },
    { category: 'V-snaren', keywords: ['v-snaar', 'v snaar', 'vsnaar', 'snaar', 'snaren', 'riem'] },
    { category: 'Variokits', keywords: ['variokit', 'variokits'] },
    { category: 'Koppelingen', keywords: ['koppeling', 'koppelingen'] },
    { category: 'Druk & Trekveren', keywords: ['drukveer', 'drukveren', 'trekveer', 'trekveren', 'veren'] },
    { category: 'Bougie & Ontsteking', keywords: ['ontsteking', 'ontstekingsdelen'] },
    { category: 'Bougies', keywords: ['bougie', 'bougies'] },
    { category: 'Bobines', keywords: ['bobine', 'bobines'] },
    { category: "CDI's & ECU's", keywords: ['cdi', 'ecu', 'ecus'] },
    { category: 'Carburateur', keywords: ['carburateur', 'carburateurs', 'carb'] },
    { category: 'Spruitstukken', keywords: ['spruitstuk', 'spruitstukken'] },
    { category: 'Aanzuigrubbers', keywords: ['aanzuigrubber', 'aanzuigrubbers'] },
    { category: 'Cilinder', keywords: ['cilinder', 'cilinders', 'cilinderkit'] },
    { category: 'Zuigers', keywords: ['zuiger', 'zuigers'] },
    { category: 'Krukas', keywords: ['krukas', 'krukassen'] },
    { category: 'Pakking', keywords: ['pakking', 'pakkingen'] },
    { category: 'Pakkingsets', keywords: ['pakkingset', 'pakkingsets'] },
    { category: 'Kapdelen', keywords: ['kap', 'kappen', 'kuipdeel', 'kuipdelen', 'body'] },
    { category: 'Kappensets', keywords: ['kappenset', 'kappensets'] },
    { category: 'Spatborden', keywords: ['spatbord', 'spatborden'] },
    { category: 'Beenschilden', keywords: ['beenschild', 'beenschilden'] },
    { category: 'Stuurdelen', keywords: ['stuur', 'stuurdeel', 'stuurdelen'] },
    { category: 'Spiegels', keywords: ['spiegel', 'spiegels'] },
    { category: 'Handvatten', keywords: ['handvat', 'handvatten'] },
    { category: 'Gaskabels', keywords: ['gaskabel', 'gaskabels'] },
    { category: 'Achterremkabels', keywords: ['achterremkabel', 'remkabel'] },
    { category: 'Kilometertellerkabels', keywords: ['kilometertellerkabel', 'tellerkabel'] },
    { category: "Accu's", keywords: ['accu', 'accus', 'batterij'] },
    { category: 'Voorvork', keywords: ['voorvork', 'voorvorkdelen'] },
    { category: 'Schokbrekers', keywords: ['schokbreker', 'schokbrekers'] },
    { category: 'Buitenband', keywords: ['band', 'banden', 'buitenband', 'buitenbanden', 'scooterband'] },
    { category: 'Binnenband', keywords: ['binnenband', 'binnenbanden'] }
  ];
  var state = {
    query: '',
    rows: [],
    localSource: null,
    timer: 0,
    requestId: 0,
    modelsLoading: null,
    observer: null,
    injecting: false
  };

  function slugify(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function currentInput() {
    return document.querySelector('#search input[name="q"], #search input[type="search"], form[action*="/search"] input[name="q"]');
  }

  function currentQuery() {
    var input = currentInput();
    return input ? String(input.value || '').trim() : '';
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function searchTokens(value) {
    return normalizeText(value).split(/\s+/).filter(Boolean);
  }

  function categorySearchText(name) {
    var key = normalizeText(name);
    var extras = [];
    CATEGORY_KEYWORD_TARGETS.forEach(function (target) {
      if (normalizeText(target.category) === key) extras = extras.concat(target.keywords || []);
    });
    return normalizeText([name].concat(extras).join(' '));
  }

  function looksLikeCode(query) {
    var compact = String(query || '').replace(/[^a-z0-9]+/gi, '');
    var digits = String(query || '').replace(/\D+/g, '');
    return /^[a-z]{0,5}\d{4,}$/i.test(compact) || (digits.length >= 8 && digits.length <= 14);
  }

  function rowUrl(row) {
    if (row.url) return row.url;
    if ((row.type === 'Model' || row.type === 'Merk') && row.title) {
      return '/pages/scooter-' + slugify(row.title);
    }
    return row.url || '#';
  }

  function rowLabel(row) {
    if (row.type === 'Model' || row.type === 'Merk' || row.type === 'Categorie') return 'Categorie:';
    return 'Categorie:';
  }

  function rowTitle(row) {
    if (row.displayTitle) return String(row.displayTitle || '').trim();
    if (row.type === 'Model' || row.type === 'Merk') return String(row.title || '').trim() + ' onderdelen';
    if (row.type === 'Categorie') return String(row.title || '').trim() + ' scooter onderdelen';
    return '';
  }

  function localSuggestionSource() {
    if (state.localSource) return state.localSource;
    var data = window.TPS_SCOOTER_FITMENT_MODELS;
    if (!data || !Array.isArray(data.makes)) return null;
    var source = [];
    var makeCategories = {};
    var modelCategories = {};
    var globalCategories = {};
    var categorySeen = {};

    function addCategory(target, category) {
      var name = category && category.name ? category.name : category;
      var key = normalizeText(name);
      if (!key) return;
      target[key] = name;
    }

    (data.models || []).forEach(function (model) {
      var makeSlug = slugify(model.make);
      var modelSlug = model.slug || slugify(model.label || [model.make, model.model].filter(Boolean).join(' '));
      makeCategories[makeSlug] = makeCategories[makeSlug] || {};
      modelCategories[modelSlug] = modelCategories[modelSlug] || {};
      (model.categories || []).forEach(function (category) {
        addCategory(globalCategories, category);
        addCategory(makeCategories[makeSlug], category);
        addCategory(modelCategories[modelSlug], category);
      });
    });
    var globalCategoryNames = Object.keys(globalCategories).map(function (key) { return globalCategories[key]; });

    data.makes.forEach(function (make) {
      var makeTitle = make.displayName || make.name;
      var makeSlug = make.slug || slugify(make.name);
      source.push({
        type: 'Merk',
        title: makeTitle,
        url: '/pages/scooter-' + makeSlug,
        scopeUrl: '/pages/scooter-' + makeSlug,
        categoryNames: Object.keys(makeCategories[makeSlug] || {}).map(function (key) { return makeCategories[makeSlug][key]; }),
        searchText: normalizeText([makeTitle, make.name].join(' '))
      });
      (make.models || []).forEach(function (model) {
        var label = model.label || [make.name, model.model].filter(Boolean).join(' ');
        var modelSlug = model.slug || slugify(label);
        source.push({
          type: 'Model',
          title: label,
          url: '/pages/scooter-' + modelSlug,
          scopeUrl: '/pages/scooter-' + modelSlug,
          categoryNames: Object.keys(modelCategories[modelSlug] || {}).map(function (key) { return modelCategories[modelSlug][key]; }),
          searchText: normalizeText([label, make.name, model.model].join(' '))
        });
      });
    });

    (data.models || []).forEach(function (model) {
      (model.categories || []).forEach(function (category) {
        var name = category && category.name;
        var key = normalizeText(name);
        if (!key || categorySeen[key]) return;
        categorySeen[key] = true;
        source.push({
          type: 'Categorie',
          title: name,
          url: '/collections/scooter-onderdelen?category=' + encodeURIComponent(name) + '&categorie=' + encodeURIComponent(name),
          searchText: categorySearchText(name)
        });
      });
    });

    state.localSource = source;
    return source;
  }

  function modelsAssetUrl() {
    if (window.TPS_SCOOTER_MODELS_ASSET_URL) return String(window.TPS_SCOOTER_MODELS_ASSET_URL || '');
    var current = SCRIPT_SRC;
    if (current && current.indexOf('tps-scooter-app-search.js') >= 0) {
      return current.replace(/tps-scooter-app-search\.js(?:\?.*)?$/, 'tps-scooter-models-v22.js');
    }
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="tps-scooter-app-search.js"], script[src*="tps-scooter-models-v22.js"]'));
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i].src || '';
      if (src.indexOf('tps-scooter-models-v22.js') >= 0) return src;
      if (src.indexOf('tps-scooter-app-search.js') >= 0) return src.replace(/tps-scooter-app-search\.js(?:\?.*)?$/, 'tps-scooter-models-v22.js');
    }
    return '';
  }

  function ensureLocalSuggestionSource(callback) {
    if (localSuggestionSource()) {
      callback(true);
      return;
    }
    if (state.modelsLoading) {
      state.modelsLoading.then(function () {
        callback(Boolean(localSuggestionSource()));
      });
      return;
    }
    var url = modelsAssetUrl();
    if (!url) {
      callback(false);
      return;
    }
    state.modelsLoading = new Promise(function (resolve) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = function () { resolve(true); };
      script.onerror = function () { resolve(false); };
      document.head.appendChild(script);
    });
    state.modelsLoading.then(function () {
      callback(Boolean(localSuggestionSource()));
    });
  }

  function aliasCategoryScore(categoryName, tokens) {
    var categoryKey = normalizeText(categoryName);
    var score = 0;
    CATEGORY_KEYWORD_TARGETS.forEach(function (target) {
      if (normalizeText(target.category) !== categoryKey) return;
      (target.keywords || []).forEach(function (keyword) {
        var key = normalizeText(keyword);
        tokens.forEach(function (token) {
          if (key === token || key.indexOf(token) === 0 || token.indexOf(key) === 0) score += 240;
        });
      });
    });
    return score;
  }

  function bestScope(source, tokens) {
    var best = null;
    source.forEach(function (row) {
      if (row.type !== 'Model' && row.type !== 'Merk') return;
      var matched = 0;
      var score = row.type === 'Model' ? -20 : 40;
      tokens.forEach(function (token) {
        var index = row.searchText.indexOf(token);
        if (index === -1) return;
        matched += 1;
        score += index === 0 ? 180 : 100 - Math.min(index, 80);
      });
      if (!matched) return;
      if (row.type === 'Model' && matched > 1) score += 90;
      if (!best || score > best.score) best = Object.assign({}, row, { score: score, matched: matched });
    });
    return best;
  }

  function categoryForScope(scope, tokens) {
    var remaining = tokens.filter(function (token) {
      return scope.searchText.indexOf(token) === -1;
    });
    if (!remaining.length) return null;
    var best = null;
    (scope.categoryNames || []).forEach(function (name) {
      var text = categorySearchText(name);
      var score = aliasCategoryScore(name, remaining);
      var matched = 0;
      remaining.forEach(function (token) {
        var index = text.indexOf(token);
        if (index === -1) return;
        matched += 1;
        score += index === 0 ? 160 : 100 - Math.min(index, 80);
      });
      if (!matched && !score) return;
      if (!best || score > best.score) best = { name: name, score: score };
    });
    return best;
  }

  function scopedCategoryRows(source, tokens) {
    var scope = bestScope(source, tokens);
    if (!scope) return [];
    var category = categoryForScope(scope, tokens);
    if (!category) return [];
    return [{
      type: 'Categorie',
      title: scope.title + ' ' + category.name,
      displayTitle: scope.title + ' ' + category.name + ' onderdelen',
      url: scope.scopeUrl + '?categorie=' + encodeURIComponent(category.name),
      searchText: normalizeText(scope.title + ' ' + category.name),
      score: 1200 + scope.score + category.score
    }];
  }

  function localRows(query) {
    var source = localSuggestionSource();
    if (!source) return null;
    var tokens = searchTokens(query);
    if (!tokens.length) return [];
    var scoped = scopedCategoryRows(source, tokens);
    return scoped.concat(source
      .map(function (row) {
        var score = 0;
        for (var i = 0; i < tokens.length; i += 1) {
          var index = row.searchText.indexOf(tokens[i]);
          if (index === -1) return null;
          score += index === 0 ? 180 : 120 - Math.min(index, 100);
        }
        score += aliasCategoryScore(row.title, tokens);
        if (row.type === 'Merk') score += 70;
        if (row.type === 'Model') score += 35;
        if (row.searchText === normalizeText(query)) score += 500;
        return Object.assign({}, row, { score: score });
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return b.score - a.score || rowTitle(a).localeCompare(rowTitle(b), 'nl');
      })
    ).slice(0, MAX_ROWS);
  }

  function normalizeRows(rows, query) {
    var categories = [];
    (rows || []).forEach(function (row) {
      if (!row || !row.title) return;
      if (row.type === 'Model' || row.type === 'Merk' || row.type === 'Categorie') categories.push(row);
    });
    var seen = {};
    return categories.filter(function (row) {
      var key = rowLabel(row) + '|' + rowUrl(row) + '|' + rowTitle(row);
      if (seen[key]) return false;
      seen[key] = true;
      return rowTitle(row);
    }).slice(0, MAX_ROWS);
  }

  function clearInjected(liveSearch) {
    liveSearch.querySelectorAll('[data-tps-search-extra]').forEach(function (node) {
      node.remove();
    });
  }

  function makeItem(row) {
    var li = document.createElement('li');
    li.setAttribute('data-tps-search-extra', '1');
    var a = document.createElement('a');
    a.href = rowUrl(row);
    a.setAttribute('data-tps-search-extra-link', '1');
    a.innerHTML = '<span class="strong">' + escapeHtml(rowLabel(row)) + '</span> ' + escapeHtml(rowTitle(row));
    a.addEventListener('pointerdown', openLinkNow);
    a.addEventListener('mousedown', openLinkNow);
    a.addEventListener('click', openLinkNow);
    li.appendChild(a);
    return li;
  }

  function frameTipUrl(query) {
    var normalized = normalizeText(query);
    var hasCortina = normalized === 'cortina' || normalized.indexOf('cortina ') === 0 || normalized.indexOf(' cortina ') >= 0 || normalized.slice(-8) === ' cortina';
    if (hasCortina) return '/pages/cortina-framenummer-zoeken?view=cortina-frame-v11';
    var hasBatavus = normalized === 'batavus' || normalized.indexOf('batavus ') === 0 || normalized.indexOf(' batavus ') >= 0 || normalized.slice(-8) === ' batavus';
    if (hasBatavus) return '/pages/batavus-framenummer';
    return '';
  }

  function insertFrameNumberTip(liveSearch, query) {
    var href = frameTipUrl(query);
    if (!href) return;
    var tip = document.createElement('p');
    tip.setAttribute('data-tps-search-extra', '1');
    tip.setAttribute('data-tps-frame-number-tip', '1');
    tip.style.margin = '-6px 0 18px';
    tip.style.fontStyle = 'italic';
    tip.style.lineHeight = '1.35';
    var link = document.createElement('a');
    link.href = href;
    link.className = 'strong inline tps-search-blue-link';
    link.style.cssText = 'color:#000096!important;text-decoration:none!important;text-decoration-color:#000096!important;text-underline-offset:2px;display:inline-block;padding-bottom:4px;';
    link.textContent = 'Tip! Zoek je framenummer!';
    link.addEventListener('mouseenter', function () { link.style.setProperty('color', '#000096', 'important'); link.style.setProperty('text-decoration', 'underline', 'important'); });
    link.addEventListener('mouseleave', function () { link.style.setProperty('color', '#000096', 'important'); link.style.setProperty('text-decoration', 'none', 'important'); });
    link.addEventListener('focus', function () { link.style.setProperty('color', '#000096', 'important'); link.style.setProperty('text-decoration', 'underline', 'important'); });
    link.addEventListener('blur', function () { link.style.setProperty('color', '#000096', 'important'); link.style.setProperty('text-decoration', 'none', 'important'); });
    link.addEventListener('pointerdown', openLinkNow);
    link.addEventListener('mousedown', openLinkNow);
    link.addEventListener('click', openLinkNow);
    tip.appendChild(link);
    var headingBlock = liveSearch.firstElementChild;
    if (headingBlock && headingBlock.parentNode === liveSearch) {
      liveSearch.insertBefore(tip, headingBlock.nextSibling);
    } else {
      liveSearch.insertBefore(tip, liveSearch.firstChild);
    }
  }

  function openLinkNow(event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var href = event.currentTarget && event.currentTarget.href;
    if (!href) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = href;
  }

  function findSuggestionList(liveSearch) {
    var headings = Array.prototype.slice.call(liveSearch.querySelectorAll('p.strong'));
    for (var i = 0; i < headings.length; i += 1) {
      if (!/suggest/i.test(headings[i].textContent || '')) continue;
      var next = headings[i].nextElementSibling;
      if (next && next.matches && next.matches('ul.l4pl')) return next;
    }
    return null;
  }

  function insertRows() {
    var liveSearch = document.getElementById('livesearch');
    if (!liveSearch || state.injecting) return;
    var query = currentQuery();
    if (query.length < MIN_QUERY_LENGTH || query !== state.query) return;
    var rows = normalizeRows(state.rows, query);
    state.injecting = true;
    clearInjected(liveSearch);
    insertFrameNumberTip(liveSearch, query);
    if (rows.length) {
      var list = findSuggestionList(liveSearch);
      if (!list) {
        var block = document.createElement('div');
        block.setAttribute('data-tps-search-extra', '1');
        var title = document.createElement('p');
        title.className = 'strong';
        title.textContent = 'Suggesties';
        list = document.createElement('ul');
        list.className = 'l4pl';
        block.appendChild(title);
        block.appendChild(list);
        var before = liveSearch.querySelector('ul.l4ca, p a.strong.inline');
        var reference = before && before.matches && before.matches('ul.l4ca') ? before : before ? before.closest('p') : null;
        liveSearch.insertBefore(block, reference && reference.parentNode === liveSearch ? reference : null);
      }
      rows.forEach(function (row) {
        list.appendChild(makeItem(row));
      });
    }
    state.injecting = false;
  }

  function fetchRows(query) {
    var requestId = ++state.requestId;
    fetch(PROXY_URL + '?q=' + encodeURIComponent(query), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : { suggestions: [] };
      })
      .then(function (data) {
        if (requestId !== state.requestId || query !== currentQuery()) return;
        state.rows = Array.isArray(data.suggestions) ? data.suggestions : [];
        insertRows();
      })
      .catch(function () {});
  }

  function schedule() {
    var query = currentQuery();
    state.query = query;
    window.clearTimeout(state.timer);
    if (query.length < MIN_QUERY_LENGTH || looksLikeCode(query)) {
      state.rows = [];
      var liveSearch = document.getElementById('livesearch');
      if (liveSearch) clearInjected(liveSearch);
      return;
    }
    var local = localRows(query);
    if (local) {
      state.rows = local;
      insertRows();
      return;
    }
    ensureLocalSuggestionSource(function (hasLocal) {
      if (query !== currentQuery()) return;
      if (!hasLocal) {
        state.timer = window.setTimeout(function () {
          fetchRows(query);
          window.setTimeout(insertRows, 300);
        }, 80);
        return;
      }
      var retryLocal = localRows(query);
      if (!retryLocal) return;
      state.rows = retryLocal;
      insertRows();
    });
  }

  function bindInputs() {
    document.querySelectorAll('#search input[name="q"], #search input[type="search"], form[action*="/search"] input[name="q"]').forEach(function (input) {
      if (input.dataset.tpsNativeSearchHelpers) return;
      input.dataset.tpsNativeSearchHelpers = '1';
      input.addEventListener('input', schedule);
      input.addEventListener('keyup', schedule);
      input.addEventListener('focus', schedule);
    });
  }

  function observeLiveSearch() {
    var liveSearch = document.getElementById('livesearch');
    if (!liveSearch || state.observer) return;
    state.observer = new MutationObserver(function () {
      if (!state.injecting) window.setTimeout(insertRows, 20);
    });
    state.observer.observe(liveSearch, { childList: true, subtree: true });
  }

  function init() {
    normalizeLegacyScooterCollectionUrl();
    bindInputs();
    observeLiveSearch();
  }

  function canonicalScopeSlug(type, make, model) {
    var data = window.TPS_SCOOTER_FITMENT_MODELS;
    var makeText = normalizeText(make);
    var modelText = normalizeText(model);
    if (data) {
      if (type === 'model' && Array.isArray(data.models)) {
        for (var i = 0; i < data.models.length; i += 1) {
          var row = data.models[i];
          if (makeText && normalizeText(row.make) !== makeText) continue;
          if (normalizeText(row.model) === modelText || normalizeText(row.label) === normalizeText([make, model].filter(Boolean).join(' '))) {
            return row.slug || slugify(row.label);
          }
        }
      }
      if (type === 'make' && Array.isArray(data.makes)) {
        for (var j = 0; j < data.makes.length; j += 1) {
          var makeRow = data.makes[j];
          if (normalizeText(makeRow.name) === makeText || normalizeText(makeRow.displayName) === makeText) {
            return makeRow.slug || slugify(makeRow.name);
          }
        }
      }
    }
    if (type === 'make' && normalizeText(make) === 'agm gy6') return 'agm';
    return slugify(type === 'model' ? [make, model].filter(Boolean).join(' ') : make);
  }

  function normalizeLegacyScooterCollectionUrl() {
    if (window.__tpsLegacyScooterCollectionRedirected) return;
    if (window.location.pathname.replace(/\/+$/, '') !== '/collections/scooter-onderdelen') return;
    var params = new URLSearchParams(window.location.search || '');
    var make = params.get('tps_make') || params.get('make') || '';
    var model = params.get('tps_model') || params.get('model') || '';
    if (!make && !model) return;
    var slug = model ? canonicalScopeSlug('model', make, model) : canonicalScopeSlug('make', make, '');
    if (!slug) return;
    var next = new URL('/pages/scooter-' + slug, window.location.origin);
    var category = params.get('tps_category') || params.get('category') || params.get('categorie') || '';
    var search = params.get('tps_zoek') || params.get('zoek') || '';
    if (category) next.searchParams.set('categorie', category);
    if (search) next.searchParams.set('zoek', search);
    window.__tpsLegacyScooterCollectionRedirected = true;
    window.location.replace(next.pathname + next.search);
  }

  document.addEventListener('DOMContentLoaded', init);
  init();
})();
/* Codex: scooter native search helpers end */
